import { DownloadDialog } from "mirador-downloaddialog";
import React from "react";
import PdfDafoLink from "./dialog/PdfDafoLink";

/* eslint-disable react/jsx-props-no-spreading */
var PdfDafoDownloadDialog = function PdfDafoDownloadDialog(props) {
  return /*#__PURE__*/React.createElement(DownloadDialog, props, /*#__PURE__*/React.createElement(PdfDafoLink, props));
};
/* eslint-enable react/jsx-props-no-spreading */

export default PdfDafoDownloadDialog;